import script from "./BlogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__